import {combineReducers} from 'redux';

import StatusBox from 'components/StatusBox';
import {default as detailReducer} from './detail';
import {headOption} from 'utils/common';

const reducer = combineReducers({
  detail: detailReducer
});
export const RENT = 'rent';
export const ONE_OFF_CHARGE = 'one_off_charge';
export const DEPOSIT = 'deposit';

export const TENANCY_SCHEDULE = {
  [ONE_OFF_CHARGE]: 'oneOffCharge',
  [DEPOSIT]: 'deposit',
  [RENT]: 'rent'
};

export const SCHEDULE_TYPES = {
  RENT: RENT,
  DEPOSIT: DEPOSIT,
  ONE_OFF_CHARGE: ONE_OFF_CHARGE
};

export const SCHEDULE_TYPES_HUMAN_VALUES = {
  RENT: 'Rent',
  DEPOSIT: 'Deposit',
  ONE_OFF_CHARGE: 'One off Charge'
};

export const CREATED_ACTION_STATUS = 'created';
export const CUSTOMER_APPROVAL_GRANTED_ACTION_STATUS =
  'customer_approval_granted';
export const CUSTOMER_APPROVAL_DENIED_ACTION_STATUS =
  'customer_approval_denied';
export const SUBMITTED_ACTION_STATUS = 'submitted';
export const CONFIRMED_ACTION_STATUS = 'confirmed';
export const CANCELLED_ACTION_STATUS = 'cancelled';
export const FAILED_ACTION_STATUS = 'failed';
export const CHARGED_BACK_ACTION_STATUS = 'charged_back';
export const CHARGEBACK_CANCELLED_ACTION_STATUS = 'chargeback_cancelled';
export const PAID_OUT_ACTION_STATUS = 'paid_out';
export const LATE_FAILURE_SETTLED_OUT_ACTION_STATUS = 'late_failure_settled';
export const CHARGEBACK_SETTLED_ACTION_STATUS = 'chargeback_settled';
export const RESUBMISSION_REQUESTED_ACTION_STATUS = 'resubmission_requested';
export const PERMANENTLY_FAILED_ACTION_STATUS = 'permanently_failed';
export const INITIATE_FAILED = 'initiate_failed';

export const PENDING_CUSTOMER_APPROVAL_STATUS = 'pending_customer_approval';
export const PENDING_SUBMISSION_STATUS = 'pending_submission';
export const SUBMITTED_STATUS = 'submitted';
export const CONFIRMED_STATUS = 'confirmed';
export const PAID_OUT_STATUS = 'paid_out';
export const CANCELLED_STATUS = 'cancelled';
export const FAILED_STATUS = 'failed';
export const CHARGED_BACK_STATUS = 'charged_back';
export const INITIATE_FAILED_STATUS = 'initiate_failed';
export const PERMANENTLY_FAILED_STATUS = 'permanently_failed';
export const RETRY_FAILED_STATUS = 'retry_failed';
export const CANCEL_FAILED_STATUS = 'cancel_failed';

export const GOCARDLESS_PAYMENT_ACTION_STATUSES = {
  [CREATED_ACTION_STATUS]: {color: StatusBox.GREEN},
  [CUSTOMER_APPROVAL_GRANTED_ACTION_STATUS]: {color: StatusBox.GREEN},
  [CUSTOMER_APPROVAL_DENIED_ACTION_STATUS]: {color: StatusBox.RED},
  [SUBMITTED_ACTION_STATUS]: {color: StatusBox.GREEN},
  [CONFIRMED_ACTION_STATUS]: {color: StatusBox.GREEN},
  [CANCELLED_ACTION_STATUS]: {color: StatusBox.RED},
  [FAILED_ACTION_STATUS]: {color: StatusBox.ORANGE},
  [CHARGED_BACK_ACTION_STATUS]: {color: StatusBox.RED},
  [CHARGEBACK_CANCELLED_ACTION_STATUS]: {color: StatusBox.GREEN},
  [PAID_OUT_ACTION_STATUS]: {color: StatusBox.GREEN},
  [LATE_FAILURE_SETTLED_OUT_ACTION_STATUS]: {color: StatusBox.RED},
  [CHARGEBACK_SETTLED_ACTION_STATUS]: {color: StatusBox.RED},
  [RESUBMISSION_REQUESTED_ACTION_STATUS]: {color: StatusBox.GREEN},
  [PERMANENTLY_FAILED_ACTION_STATUS]: {color: StatusBox.RED},
  [INITIATE_FAILED]: {color: StatusBox.RED},
  [PENDING_SUBMISSION_STATUS]: {color: StatusBox.LIGHT_ORANGE},
  [CANCEL_FAILED_STATUS]: {color: StatusBox.ORANGE}
};

export const GOCARDLESS_PAYMENT_STATUSES = {
  [PENDING_CUSTOMER_APPROVAL_STATUS]: {color: StatusBox.LIGHT_ORANGE},
  [PENDING_SUBMISSION_STATUS]: {color: StatusBox.LIGHT_ORANGE},
  [SUBMITTED_STATUS]: {color: StatusBox.LIGHT_ORANGE},
  [CONFIRMED_STATUS]: {color: StatusBox.GREEN},
  [PAID_OUT_STATUS]: {color: StatusBox.GREEN},
  [CANCELLED_STATUS]: {color: StatusBox.LIGHT_GREY},
  [FAILED_STATUS]: {color: StatusBox.DARK_DUSTY_PINK},
  [CHARGED_BACK_STATUS]: {color: StatusBox.RED},
  [INITIATE_FAILED_STATUS]: {color: StatusBox.RED},
  [PERMANENTLY_FAILED_STATUS]: {color: StatusBox.RED},
  [RETRY_FAILED_STATUS]: {color: StatusBox.ORANGE},
  [CANCEL_FAILED_STATUS]: {color: StatusBox.ORANGE}
};

export const CREDIT_CARD_MACHINE = 'CREDIT_CARD_MACHINE';

export const SCHEDULE_ITEM_TYPES = {
  INVOICE: 'invoice',
  CREDIT_NOTE: 'creditNote',
  PAYMENT: 'payment',
  OVERPAYMENT: 'overpayment',
  REFUND: 'refund',
  DRAFT_INVOICE: 'draftInvoice'
};

export const ACCOUNT_TYPES = {
  BANK: 'BANK'
};

export const SETUP_GOCARDLESS_TABS = {
  SUGGESTED: 'Suggested',
  SEARCH_GOCARDLESS: 'Search GoCardless',
  SEND_INVITATION: 'Send New Invite'
};

const GC_MANDATE_HUMAN_READABLE_STATUSES = [
  {key: 'pending_customer_approval', label: 'Pending Customer Approval'},
  {key: 'pending_submission', label: 'Pending Submission'},
  {key: 'submitted', label: 'Submitted'},
  {key: 'active', label: 'Active'},
  {key: 'failed', label: 'Failed'},
  {key: 'cancelled', label: 'Cancelled'},
  {key: 'expired', label: 'Expired'},
  {key: 'no_mandate', label: 'No Mandate'}
];

export const humanReadableGCMandateStatus = status => {
  return headOption(
    GC_MANDATE_HUMAN_READABLE_STATUSES.filter(x => x.key == status),
    x => x.label
  );
};

const GC_INVITATION_HUMAN_READABLE_STATUSES = [
  {key: 'complete', label: 'Complete'},
  {key: 'void', label: 'Void'},
  {key: 'pending', label: 'Pending'},
  {key: 'no_invitation', label: 'No Invitation'}
];

export const humanReadableGCInvitationStatus = status => {
  return headOption(
    GC_INVITATION_HUMAN_READABLE_STATUSES.filter(x => x.key == status),
    x => x.label
  );
};

export const GC_STATUSES_FOR_BOOKING_TRACKER = {
  PENDING_CUSTOMER_APPROVAL_STATUS: 'pending_customer_approval',
  PENDING_SUBMISSION_STATUS: 'pending_submission',
  SUBMITTED_STATUS: 'submitted',
  ACTIVE_STATUS: 'active',
  FAILED_STATUS: 'failed',
  CANCELLED_STATUS: 'cancelled',
  EXPIRED_STATUS: 'expired',
  NO_MANDATE_STATUS: 'no_mandate',
  COMPLETE_STATUS: 'complete',
  VOID_STATUS: 'void',
  PENDING_STATUS: 'pending',
  NO_INVITATION_STATUS: 'no_invitation'
};

const GC_HUMAN_READABLE_STATUSES_FOR_BOOKING_TRACKER = [
  // Mandate
  {
    key: [GC_STATUSES_FOR_BOOKING_TRACKER.PENDING_CUSTOMER_APPROVAL_STATUS],
    label: 'Pending Customer Approval'
  },
  {
    key: [GC_STATUSES_FOR_BOOKING_TRACKER.PENDING_SUBMISSION_STATUS],
    label: 'Pending Submission'
  },
  {
    key: [GC_STATUSES_FOR_BOOKING_TRACKER.SUBMITTED_STATUS],
    label: 'Submitted'
  },
  {
    key: [GC_STATUSES_FOR_BOOKING_TRACKER.ACTIVE_STATUS],
    label: 'Active'
  },
  {
    key: [GC_STATUSES_FOR_BOOKING_TRACKER.FAILED_STATUS],
    label: 'Failed'
  },
  {
    key: [GC_STATUSES_FOR_BOOKING_TRACKER.CANCELLED_STATUS],
    label: 'Cancelled'
  },
  {
    key: [GC_STATUSES_FOR_BOOKING_TRACKER.EXPIRED_STATUS],
    label: 'Expired'
  },
  {
    key: [GC_STATUSES_FOR_BOOKING_TRACKER.NO_MANDATE_STATUS],
    label: 'No Mandate'
  },
  // Invite
  {
    key: [GC_STATUSES_FOR_BOOKING_TRACKER.COMPLETE_STATUS],
    label: 'Complete'
  },
  {key: [GC_STATUSES_FOR_BOOKING_TRACKER.VOID_STATUS], label: 'Void'},
  {
    key: [GC_STATUSES_FOR_BOOKING_TRACKER.PENDING_STATUS],
    label: 'Pending'
  },
  {
    key: [GC_STATUSES_FOR_BOOKING_TRACKER.NO_INVITATION_STATUS],
    label: 'No Invitation'
  }
];

export const humanReadableGCStatusForBookingTracker = status => {
  return headOption(
    GC_HUMAN_READABLE_STATUSES_FOR_BOOKING_TRACKER.filter(x => x.key == status),
    x => x.label
  );
};

export const gcStatusForBookingTrackerFromHumanReadable = status => {
  return headOption(
    GC_HUMAN_READABLE_STATUSES_FOR_BOOKING_TRACKER.filter(
      x => x.label == status
    ),
    x => x.key
  );
};

export const GOCARDLESS_STATUSES_FOR_BOOKING_TRACKER = {
  [GC_STATUSES_FOR_BOOKING_TRACKER.PENDING_CUSTOMER_APPROVAL_STATUS]: {
    color: StatusBox.LIGHT_ORANGE
  },
  [GC_STATUSES_FOR_BOOKING_TRACKER.PENDING_SUBMISSION_STATUS]: {
    color: StatusBox.LIGHT_ORANGE
  },
  [GC_STATUSES_FOR_BOOKING_TRACKER.SUBMITTED_STATUS]: {
    color: StatusBox.LIGHT_ORANGE
  },
  [GC_STATUSES_FOR_BOOKING_TRACKER.ACTIVE_STATUS]: {color: StatusBox.GREEN},
  [GC_STATUSES_FOR_BOOKING_TRACKER.FAILED_STATUS]: {
    color: StatusBox.DARK_DUSTY_PINK
  },
  [GC_STATUSES_FOR_BOOKING_TRACKER.CANCELLED_STATUS]: {
    color: StatusBox.LIGHT_GREY
  },
  [GC_STATUSES_FOR_BOOKING_TRACKER.EXPIRED_STATUS]: {color: StatusBox.GREY},
  [GC_STATUSES_FOR_BOOKING_TRACKER.NO_MANDATE_STATUS]: {
    color: StatusBox.ORANGE
  },
  [GC_STATUSES_FOR_BOOKING_TRACKER.COMPLETE_STATUS]: {color: StatusBox.GREEN},
  [GC_STATUSES_FOR_BOOKING_TRACKER.VOID_STATUS]: {color: StatusBox.LIGHT_GREY},
  [GC_STATUSES_FOR_BOOKING_TRACKER.PENDING_STATUS]: {
    color: StatusBox.LIGHT_ORANGE
  },
  [GC_STATUSES_FOR_BOOKING_TRACKER.NO_INVITATION_STATUS]: {
    color: StatusBox.ORANGE
  }
};

export default reducer;
export * from './detail';
